module.exports = __webpack_public_path__ + "static/media/08.916d227a.jpg";